import { connect } from 'react-redux';
import _ from 'lodash';
import EmergencyPersonnel from './EmergencyPersonnel';
import { translations } from '../../selectors/translations';
import './css/index.scss';
import { setEmergencyBuildingId } from '../../actions/whiteLabel/booking';

const mapStateToProps = state => {
  return {
    emergencyBuildingId: state.whiteLabel.booking.get('emergencyBuildingId'),
  };
};

const mapDispatchProps = dispatch => {
  return {
    setEmergencyBuildingId: id => dispatch(setEmergencyBuildingId(id)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(EmergencyPersonnel);
